import SharedIntegrations from "../classes/SharedIntegrations";
import { $localStorage } from "../../features";

const defaultState = () => ({
  data: [],
  filter_string: $localStorage.get("shared_integrations.filter_string") || "",
  filter_strings: $localStorage.get("shared_integrations.filter_strings") || []
});

const state = defaultState();

// getters
const getters = {
  integrations: (state, getters) => {
    if (state.filter_string || state.filter_strings) {
      return state.data.filter(v =>
        v.beShownForFilterString(state.filter_string, state.filter_strings)
      );
    }
    return state.data;
  }
};

// actions
const actions = {
  getData(store, variables = {}) {
    return SharedIntegrations.loadListWithRelations();
  },
  removeFromDataByUUID(store, uuid) {
    store.commit(
      "setData",
      store.state.data.filter(v => v.uuid !== uuid)
    );
  }
};

// mutations
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  setData(state, data) {
    state.data = SharedIntegrations.getSelfList(data);
  },
  addToFilterStrings(state) {
    if (
      state.filter_string &&
      !state.filter_strings.includes(state.filter_string)
    ) {
      state.filter_strings.push(state.filter_string);
      state.filter_string = "";
    }
    $localStorage.set(
      "shared_integrations.filter_strings",
      state.filter_strings
    );
    $localStorage.set("shared_integrations.filter_string", state.filter_string);
  },
  deleteFromFilterStrings(state, string) {
    state.filter_strings.splice(state.filter_strings.indexOf(string), 1);
    $localStorage.set(
      "shared_integrations.filter_strings",
      state.filter_strings
    );
  },
  clearAllFilters(state) {
    $localStorage.set(
      "shared_integrations.filter_strings",
      (state.filter_strings = [])
    );
    $localStorage.set(
      "shared_integrations.filter_string",
      (state.filter_string = "")
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
